const GLOBAL_EVENT_LISTENERS = Object.freeze({
    ESC: 'esc',
    CTRL_SHIFT_F: 'ctrlShiftF',
    CTRL_SHIFT_Q: 'ctrlShiftQ',
    CTRL_SPACE: 'ctrlSpace',
});

export default GLOBAL_EVENT_LISTENERS;
